import { ITab } from '../../_models/tabsInterface'

export const headerTabs: ITab[] = [
  {
    id: 1,
    label: 'dashboard',
    path: '/super-admin/dashboard',
  },
  {
    id: 2,
    label: 'businessManagement',
    path: '/super-admin/business-management',
  },
  {
    id: 3,
    label: 'userManagement',
    path: '/super-admin/user-management',
  },
  {
    id: 4,
    label: 'customers',
    path: '/super-admin/customers',
  },
]
